import { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";

export default function ShopAssignmentDialog({
  open,
  firewall,
  shops = [],
  loading = false,
  onClose,
  onSubmit,
}) {
  const [shopIds, setShopIds] = useState([]);
  const [isPrimary, setIsPrimary] = useState(true);
  const [role, setRole] = useState("shared");

  useEffect(() => {
    if (open) {
      setShopIds([]);
      setIsPrimary(true);
      setRole("shared");
    }
  }, [open]);

  const assignedIds = useMemo(
    () => new Set((firewall?.shops || []).map((shop) => shop.id)),
    [firewall],
  );
  const options = shops.filter((shop) => !assignedIds.has(shop.id));
  const selected = options.filter((shop) => shopIds.includes(shop.id));

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Assign shops</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "grid", gap: 2, pt: 0.5 }}>
          <Autocomplete
            multiple
            options={options}
            value={selected}
            onChange={(_, value) => setShopIds(value.map((shop) => shop.id))}
            getOptionLabel={(shop) => `${shop.shop_name} (${shop.shop_code})`}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => <TextField {...params} label="Shops" />}
          />
          <FormControl fullWidth>
            <InputLabel>Connection role</InputLabel>
            <Select value={role} label="Connection role" onChange={(event) => setRole(event.target.value)}>
              <MenuItem value="primary">Primary</MenuItem>
              <MenuItem value="secondary">Secondary</MenuItem>
              <MenuItem value="backup">Backup</MenuItem>
              <MenuItem value="shared">Shared</MenuItem>
            </Select>
          </FormControl>
          <FormControlLabel
            control={<Switch checked={isPrimary} onChange={(event) => setIsPrimary(event.target.checked)} />}
            label="Mark as primary assignment"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button
          variant="contained"
          disabled={loading || shopIds.length === 0}
          onClick={() => onSubmit({ shop_ids: shopIds, is_primary: isPrimary, connection_role: role })}
        >
          {loading ? "Assigning..." : "Assign shops"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
